"use client";

import { create } from "zustand";

interface User {
  id: number;
  email: string;
  first_name: string | null;
  last_name: string | null;
  userType: number;
  created_at: string | null;
  projects_total: number;
  orders_total: number;
  status: number;
  uid?: string;
  avatar?: string | null;
}

interface AdminState {
  users: User[];
  metrics: {
    totalUsers: number;
    activeUsers: number;
    adminUsers: number;
    revokedSessions: number;
  };
  setUsers: (users: User[]) => void;
  updateUser: (user: User) => void;
  setMetrics: (metrics: AdminState["metrics"]) => void;
  incrementRevokedSessions: () => void;
}

export const useAdminStore = create<AdminState>((set) => ({
  users: [],
  metrics: {
    totalUsers: 0,
    activeUsers: 0,
    adminUsers: 0,
    revokedSessions: 0,
  },
  setUsers: (users) => set({ users }),
  updateUser: (updatedUser) =>
    set((state) => {
      const newUsers = state.users.map((user) =>
        user.id === updatedUser.id ? updatedUser : user
      );
      return {
        users: newUsers,
        metrics: {
          ...state.metrics,
          totalUsers: newUsers.length,
          activeUsers: newUsers.filter((u) => u.status === 1).length,
          adminUsers: newUsers.filter((u) => u.userType === 1).length,
        },
      };
    }),
  setMetrics: (metrics) => set({ metrics }),
  incrementRevokedSessions: () =>
    set((state) => ({
      metrics: { ...state.metrics, revokedSessions: state.metrics.revokedSessions + 1 },
    })),
}));